import React, { use, useState } from 'react';
import { FaApple, FaGoogle, FaMicrosoft } from 'react-icons/fa';
import MiddleLine from '../assets/images/mid partition.png';
import LeftHandEmoji from '../assets/images/Backhand Index Pointing Left.svg';
import Navbar from '../components/Navbar';
import axios from 'axios';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import OAuthComponents from '../components/OAuthComponents';
import { BackgroundDiv } from '../components/StyledComponents';
import posthog from 'posthog-js';
import {
  Box,
  Button,
  Divider,
  TextField,
  Typography,
  Link as MUILink,
  CircularProgress,
  Stack,
  useTheme,
  styled,
} from '@mui/material';
import SignupFooter from '../components/SignupFooter';
import api from '../api/axios';

const Signup = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const theme = useTheme();

  const handleSignup = async () => {
    setLoading(true);
    try {
      const res = await axios.post(`${api}/auth/signup`, {
        email: email.toLocaleLowerCase(),
      });

      // Store token in localStorage (or cookies if preferred)
      localStorage.setItem('token', res.data.token);

      posthog.capture('signup_email_submitted');

      // TEMP DISABLE: Email verification is disabled. Redirect directly to signup form.
      // TODO: When re-enabling verification, restore the alert and remove this redirect.
      // The user should then click the verification link in their email to proceed.
      navigate(`/signup?token=${res.data.token}`);
    } catch (err) {
      const msg = err.response?.data?.msg || 'Signup failed. Please try again.';
      console.error(err);
      setError(msg);
      posthog.captureException(err, {
        extra: { context: 'signup_email_submitted' },
      });
      console.error(
        '❌ Signup failed:',
        err.response?.data?.msg || err.message
      );
    }
    setLoading(false);
  };

  return (
    <BackgroundDiv>
      <Navbar />
      <Box
        display="flex"
        justifyContent="center"
        alignItems="flex-start"
        minHeight="60vh"
        mt={{ xs: 2, md: 2, lg: '127px' }} // smaller top margin on mobile
        px={{ xs: 2, sm: 4 }} // padding adapts
      >
        <Box
          display="flex"
          width="100%"
          justifyContent="flex-start"
          flexDirection={{
            xs: 'column',
            sm: 'column',
            md: 'column',
            lg: 'row',
          }}
          alignItems={{
            xs: 'center',
            sm: 'column',
            md: 'column',
            lg: 'flex-start',
          }}
          gap={{ xs: 4, sm: 4, md: 4, lg: 0 }} // spacing between sections on mobile
        >
          <Box
            sx={{
              flex: 1,
              maxWidth: { xs: '100%', md: '50%' },
              textAlign: { xs: 'center', md: 'left' }, // center text on mobile
            }}
            ml={{ xs: 0, md: 0, lg: '152px' }}
          >
            <Typography
              fontWeight={500}
              gutterBottom
              fontSize={{ xs: '20px', sm: '25px', md: '30px', lg: '50px' }}
            >
              Create an Account
            </Typography>
            <Typography
              mb={{ xs: 3, md: '94px' }}
              fontSize={{ xs: '16px', sm: '20px', md: '24px' }}
            >
              <span style={{ opacity: '70%' }}>Already have an account </span>
              <WhiteLink
                href="/login"
                fontWeight={600}
                fontSize="inherit"
                underline="always"
              >
                Login
              </WhiteLink>{' '}
              <img
                src={LeftHandEmoji}
                alt="emoji"
                width={20}
                style={{ verticalAlign: 'middle' }}
              />
            </Typography>

            <Stack
              spacing={{ xs: 3, sm: '42px' }}
              width={{ xs: '100%', sm: '387px' }}
              mx={{ xs: 'auto', md: 0 }} // center on mobile
            >
              <TextField
                fullWidth
                label="Email address"
                variant="outlined"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                sx={{ height: '60px' }}
              />
              {error && (
                <Typography variant="caption" color="error">
                  {error}
                </Typography>
              )}
              <GradientButton
                fullWidth
                onClick={handleSignup}
                disabled={loading}
              >
                {loading ? <CircularProgress size={24} /> : 'Continue'}
              </GradientButton>
            </Stack>
          </Box>

          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            px={20}
          >
            <Divider
              orientation="vertical"
              flexItem
              sx={{
                height: { xs: '0px', sm: '0px', md: '0px', lg: '300px' },
                mt: { xs: 0, sm: 0, md: 0, lg: '40px' },
                mb: { xs: 0, sm: 0, md: 0, lg: '40px' },
                //   "&::before, &::after": {
                //   borderColor: theme.palette.mode === 'dark' ? '#ffffff' : '#454545',
                //   borderWidth: '2px',
                // },
              }}
            >
              Or
            </Divider>
          </Box>

          <Box
            flex={1}
            sx={{
              width: { xs: '100%', sm: '100%', md: '100%', lg: '50%' },
              marginTop: { xs: 4, sm: 4, md: 10, lg: 10 },
            }}
            mb={4}
          >
            <OAuthComponents />
          </Box>
        </Box>
      </Box>

      <SignupFooter />
    </BackgroundDiv>
  );
};

// const StyledTypography = styled(Typography)(() => ({
//   color:
// }))

const GradientButton = styled(Button)(({ theme }) => ({
  background: theme.palette.mode === 'dark' ? '#fff' : '#000',
  color: theme.palette.mode === 'dark' ? '#000' : '#fff',
  padding: '10px 24px',
  borderRadius: '30px',
  textTransform: 'none',
  fontWeight: 'bold',
  '&:hover': {
    background: '#f2f2f2',
  },
}));

const WhiteLink = styled(MUILink)(({ theme }) => ({
  color: theme.palette.mode === 'dark' ? 'white' : 'black',
  textDecoration: 'underline',
  '&:hover': {
    color: theme.palette.mode === 'dark' ? 'white' : 'black',
    textDecoration: 'underline',
  },
}));

export default Signup;